import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Payee.Save.IRequest;
type Response = Api.Core.Payee.Save.IResponse;
type Headers = Api.Core.Payee.Save.IHeaders;
const url = '/api/Claims/Payee';
export default async function payeeSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
